/*
========================================================
LOG DE CARREGAMENTO
========================================================
Confirma no console que a landing page carregou corretamente
========================================================
*/

console.log("LP Yanmei carregada com sucesso 🚀");


/*
========================================================
CONFIGURAÇÃO DO CONTADOR
========================================================
Define a data FINAL REAL da campanha.
Formato:
ANO-MÊS-DIA T HORA:MINUTO:SEGUNDO
========================================================
*/

const alvo = new Date("2026-05-25T00:00:00");


/*
========================================================
FUNÇÃO QUE ATUALIZA O CONTADOR
========================================================
Calcula dias, horas, minutos e segundos restantes
e renderiza dentro do elemento #contador
========================================================
*/

function atualizarContador() {

  const agora = new Date().getTime();
  const distancia = alvo.getTime() - agora;

  /*
  ========================================================
  Quando o contador terminar
  ========================================================
  */

  if (distancia <= 0) {

    document.getElementById("contador").innerHTML =
      "00d 00h 00m 00s";

    clearInterval(intervalo);

    return;
  }

  /*
  ========================================================
  Cálculo do tempo restante
  ========================================================
  */

  const diasRestantes = Math.floor(
    distancia / (1000 * 60 * 60 * 24)
  );

  const horasRestantes = Math.floor(
    (distancia % (1000 * 60 * 60 * 24)) /
    (1000 * 60 * 60)
  );

  const minutosRestantes = Math.floor(
    (distancia % (1000 * 60 * 60)) /
    (1000 * 60)
  );

  const segundosRestantes = Math.floor(
    (distancia % (1000 * 60)) / 1000
  );

  /*
  ========================================================
  Atualiza HTML do contador
  ========================================================
  */

  document.getElementById("contador").innerHTML =
    `${String(diasRestantes).padStart(2, '0')}d ` +
    `${String(horasRestantes).padStart(2, '0')}h ` +
    `${String(minutosRestantes).padStart(2, '0')}m ` +
    `${String(segundosRestantes).padStart(2, '0')}s`;
}


/*
========================================================
INICIA CONTADOR
========================================================
Executa imediatamente ao carregar a página
========================================================
*/

atualizarContador();


/*
========================================================
ATUALIZA CONTADOR A CADA 1 SEGUNDO
========================================================
*/

const intervalo = setInterval(
  atualizarContador,
  1000
);

/*
========================================================
MÁSCARA TELEFONE / WHATSAPP
========================================================
Formata automaticamente o número enquanto o usuário digita.
========================================================
Formato:
(11) 99999-9999
========================================================
*/

document.addEventListener('DOMContentLoaded', () => {

    const inputs = document.querySelectorAll(
      '#whatsapp, .whatsapp-modal'
    );

    if (!inputs.length) return;

    inputs.forEach((input) => {

        input.addEventListener('input', (e) => {

            let value = e.target.value.replace(/\D/g, '');

            value = value.slice(0, 11);

            if (value.length > 0) {
                value = '(' + value;
            }

            if (value.length > 3) {
                value = value.slice(0, 3) + ') ' + value.slice(3);
            }

            if (value.replace(/\D/g, '').length <= 10) {

                if (value.replace(/\D/g, '').length > 6) {

                    value = value.replace(
                        /(\(\d{2}\)\s\d{4})(\d+)/,
                        '$1-$2'
                    );

                }

            } else {

                if (value.replace(/\D/g, '').length > 7) {

                    value = value.replace(
                        /(\(\d{2}\)\s\d{5})(\d+)/,
                        '$1-$2'
                    );

                }

            }

            e.target.value = value;

        });

    });

});

/*
========================================================
MODAL VIP
========================================================
*/

document.addEventListener('DOMContentLoaded', () => {

    const modal = document.getElementById('modalVip');

    if (!modal) return;

    /*
    ====================================================
    ABRIR MODAL
    ====================================================
    */

    const botoesAbrir = document.querySelectorAll(
        '.abrir-modal-vip'
    );

    botoesAbrir.forEach((botao) => {

        botao.addEventListener('click', () => {

            modal.classList.add('ativo');

            document.body.style.overflow = 'hidden';

        });

    });

    /*
    ====================================================
    FECHAR MODAL
    ====================================================
    */

    const botoesFechar = document.querySelectorAll(
        '.fechar-modal'
    );

    botoesFechar.forEach((botao) => {

        botao.addEventListener('click', () => {

            modal.classList.remove('ativo');

            document.body.style.overflow = '';

        });

    });

});

/*
========================================================
BOTÃO ENVIANDO
========================================================
Impede clique duplo no submit
========================================================
*/

document.addEventListener('DOMContentLoaded', () => {

    const formularios = document.querySelectorAll(
        '.newsletter-form, .newsletter-form-modal'
    );

    if (!formularios.length) return;

    formularios.forEach((formulario) => {

        formulario.addEventListener('submit', () => {

            const botao = formulario.querySelector(
                'button[type="submit"]'
            );

            if (!botao) return;

            /*
            ================================================
            DESABILITA BOTÃO
            ================================================
            */

            botao.disabled = true;

            /*
            ================================================
            ALTERA TEXTO
            ================================================
            */

            botao.innerText = 'ENVIANDO...';

            /*
            ================================================
            OPACIDADE VISUAL
            ================================================
            */

            botao.style.opacity = '.7';

            /*
            ================================================
            REMOVE CLIQUES
            ================================================
            */

            botao.style.pointerEvents = 'none';

        });

    });

});

/*
========================================================
VALIDAÇÃO REALTIME
========================================================
*/

document.addEventListener('DOMContentLoaded', () => {

    const formularios = document.querySelectorAll(
        '.newsletter-form, .newsletter-form-modal'
    );

    formularios.forEach((formulario) => {

        const telefone = formulario.querySelector(
            '.validar-telefone'
        );

        const email = formulario.querySelector(
            '.validar-email'
        );

        const nome = formulario.querySelector(
            'input[name="contact[first_name]"]'
        );

        const botao = formulario.querySelector(
            'button[type="submit"]'
        );

        /*
        ================================================
        DESABILITA INICIALMENTE
        ================================================
        */

        if (botao) {
            botao.disabled = true;
        }

        /*
        ================================================
        VALIDAR FORMULÁRIO
        ================================================
        */

        function validarFormulario() {

            let telefoneValido = false;
            let emailValido = false;
            let nomeValido = false;

            /*
            ============================================
            TELEFONE
            ============================================
            */

            if (telefone) {

                const numeros =
                  telefone.value.replace(/\D/g, '');

                const erroTelefone =
                  telefone.parentElement.querySelector(
                    '.mensagem-erro'
                  );

                if (
                    numeros.length < 10 &&
                    telefone.dataset.touched === 'true'
                ) {

                    erroTelefone.innerText =
                      'Digite um telefone válido';

                    erroTelefone.classList.add('ativo');

                    telefoneValido = false;

                } else {

                    erroTelefone.innerText = '';

                    erroTelefone.classList.remove('ativo');

                    telefoneValido =
                      numeros.length === 10 ||
                      numeros.length === 11;

                }

            }

            /*
            ============================================
            EMAIL
            ============================================
            */

            if (email) {

                const erroEmail =
                  email.parentElement.querySelector(
                    '.mensagem-erro'
                  );

                const regexEmail =
                  /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                if (
                    !regexEmail.test(email.value) &&
                    email.dataset.touched === 'true'
                ) {

                    erroEmail.innerText =
                      'Digite um e-mail válido';

                    erroEmail.classList.add('ativo');

                    emailValido = false;

                } else {

                    erroEmail.innerText = '';

                    erroEmail.classList.remove('ativo');

                    emailValido =
                      email.value.length > 0 &&
                      regexEmail.test(email.value);

                }

            }

            /*
            ============================================
            NOME
            ============================================
            */

            if (nome) {

                nomeValido =
                  nome.value.trim().length >= 3;

            }

            /*
            ============================================
            LIBERA BOTÃO
            ============================================
            */

            const formularioValido =
                telefoneValido &&
                emailValido &&
                nomeValido;

            /*
            ============================================
            ATIVA BOTÃO
            ============================================
            */

            if (formularioValido) {

                botao.disabled = false;

                botao.style.opacity = '1';

                botao.style.pointerEvents = 'all';

            }

            /*
            ============================================
            DESATIVA BOTÃO
            ============================================
            */

            else {

                botao.disabled = true;

                botao.style.opacity = '.5';

                botao.style.pointerEvents = 'none';

            }

        }

        /*
        ================================================
        EVENTOS
        ================================================
        */

        [telefone, email, nome].forEach((campo) => {

          if (!campo) return;

          /*
          ============================================
          INPUT
          ============================================
          */

          campo.addEventListener('input', () => {

              campo.dataset.touched = 'true';

              validarFormulario();

          });

          /*
          ============================================
          BLUR
          ============================================
          */

          campo.addEventListener('blur', () => {

              campo.dataset.touched = 'true';

              validarFormulario();

          });

      });

    });

});